import session from '../Services/Session';
import { IconButton, Popover } from '@mui/material';
import { Button } from '@mui/material';
import Field from '../Components/Field';
import { EventCheckMode } from '../Services/EventsStore';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useActions } from '../Hooks/Actions';
import "./EventQuickStats.scss"
import { formatTime } from '../Utils';
import { useEventStats } from '../Hooks/EventStatsContext';
import { useEffect } from 'react';


interface IEventQuickStatsProps {

    onClose?: () => void;
    anchor: HTMLElement;
    origin: "top" | "bottom" | number;

}

export default function EventQuickStats(props: IEventQuickStatsProps) {

    const actions = useActions();

    const stats = useEventStats();

    useEffect(() => {
        if (props.anchor)
            stats.updateAsync();
    }, [props.anchor]);

    if (!stats?.eventId)
        return null;

    const fields = [];

    if (stats.lastStats) {
        for (const key in stats.lastStats)
            fields.push(<Field key={key} label={key}>{stats.lastStats[key]}</Field>)
    }

    return (
        <Popover
            anchorOrigin={{
                vertical: props.origin,
                horizontal: 'center',
            }}
            
            transformOrigin={{
                vertical: props.origin == "bottom" ? "top" : 'bottom',
                horizontal: 'center',
            }}
           
            anchorEl={props.anchor}
            open={props.anchor !== null}
            onClose={props.onClose}
        >
            <div className="quick-stats">
                <header>
                    <span>Statistiche</span>
                    <IconButton onClick={() => stats.updateAsync(true)}><RefreshIcon /></IconButton>
                </header>
                <div className="last-update">Aggiornato alle: {formatTime(stats.lastUpdate)}</div>
                <section>
                    <fieldset>
                        {fields}
                    </fieldset>
                    <div className="actions">
                        {stats.mode === EventCheckMode.Scan && <Button onClick={() => actions.scanHistory(stats.eventId)}>Cronologia</Button>}
                        <Button onClick={() => actions.openMonitorAsync(stats.eventId)}>Monitor</Button>
                    </div>
                </section>
            </div>
        </Popover>
    );
}